import React, { useState } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { Modal } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { SubmissionError } from 'redux-form/immutable';
import DeleteAccountForm from 'components/DeleteAccountForm';
import NotificationWindow from 'components/NotificationWindow';
import {
  ERROR_INVALID_PASSWORD,
  ERROR_SERVER_ERROR,
  SUCCESS_ACCOUNT_DELETED_MESSAGE
} from 'utils/messages';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import './DeleteAccountModal.css';

const DeleteAccountModal = ({ closeModal, showDeleteAccount, deleteUser }) => {
  const [successful, setSuccessful] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleCloseModal = () => {
    closeModal();
    setErrorMessage('');
  };

  const handleSubmit = event => {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);
    const values = Object.fromEntries(formData.entries());

    return deleteUser(values.password)
      .then(resp => {
        const result = resp && resp.data && resp.data.deleteUser;
        if (result === 'success') {
          setSuccessful(true);
        } else if (result === 'incorrectPassword') {
          setErrorMessage(ERROR_INVALID_PASSWORD);
          throw new SubmissionError({ _error: ERROR_INVALID_PASSWORD });
        } else {
          const error = result === 'error' && ERROR_SERVER_ERROR;
          setErrorMessage(ERROR_SERVER_ERROR);
          throw new SubmissionError({ _error: error });
        }
        return resp;
      })
      .catch(error => {
        if (error instanceof SubmissionError) {
          throw error;
        } else {
          if (error.message) {
            console.error(error.message);
          } else {
            console.error(JSON.stringify(error));
          }
          throw new SubmissionError({ _error: ERROR_SERVER_ERROR });
        }
      });
  };

  const closeButton = successful ? (
    <Link to={'/login'} onClick={closeModal} type="button">
      <img src={CloseIcon} alt="Close Dialog" className="close-modal-button" />
    </Link>
  ) : (
    <button
      onClick={handleCloseModal}
      type="button"
      className="close-modal-button"
    >
      <img src={CloseIcon} alt="Close Dialog" />
    </button>
  );

  const content = successful ? (
    <NotificationWindow
      message={SUCCESS_ACCOUNT_DELETED_MESSAGE}
      closeUrl="/login"
      variant={'success'}
    />
  ) : (
    <DeleteAccountForm
      handleSubmit={handleSubmit}
      closeModal={handleCloseModal}
      errorMessage={errorMessage}
    />
  );

  return (
    <Modal
      show={showDeleteAccount}
      backdrop={'static'}
      className="delete-account-modal"
    >
      <Modal.Body>
        <Helmet>
          <title>Delete Account</title>
        </Helmet>
        {content}
      </Modal.Body>
      {closeButton}
    </Modal>
  );
};

const DELETE_ACCOUNT_MUTATION = gql`
  mutation DeleteAccount($input: DeleteUserInput!) {
    deleteUser(input: $input)
  }
`;

const withData = graphql(DELETE_ACCOUNT_MUTATION, {
  props: ({ ownProps, mutate }) => ({
    deleteUser: password =>
      mutate({
        variables: { input: { password } }
      })
  })
});

export default withData(DeleteAccountModal);
